import React, { Fragment, useRef, useState, } from "react";
import { Tooltip } from "..";
import { v4 as uuidv4 } from "uuid";
export const DropdownDivider = () => React.createElement("hr", null);
export const Dropdown = ({ children, ariaLabelledBy, dropdownRef, className, dataTestId, dataId, dataHook, }) => (React.createElement("ul", { ref: dropdownRef, className: `dropdown-menu ${className ?? ""}`, role: "menu", "aria-labelledby": ariaLabelledBy, "data-testid": dataTestId, "data-id": dataId, "data-hook": dataHook }, children));
export function DropdownOptions({ options, id, item, onChange, }) {
    const [hoveredItemIndex, setHoveredItemIndex] = useState(null);
    const [openLeft, setOpenLeft] = useState(false);
    const measured = useRef(false);
    return (React.createElement(Fragment, null, options
        .filter((option) => toCheckIfDisplayed(option, item))
        .map((option, i) => {
        if (option.divider) {
            return React.createElement(DropdownDivider, { key: i });
        }
        let listItemClassName = "";
        if (option.sectionHeader) {
            listItemClassName = "dropdown-menu-section-header";
        }
        else if (!option.onClick && !option.link && !option.subItems) {
            listItemClassName = "dropdown-menu-no-link";
        }
        else {
            listItemClassName = "dropdown-menu-link";
        }
        const hasSubItems = option.subItems && option.subItems.length > 0;
        const isHovered = hoveredItemIndex === i;
        const isLeftSubmenu = openLeft || option.submenuDirection === "left";
        const dataAttributes = {
            key: i,
            id: option.id && `${id}--${option.id}`,
            className: `${listItemClassName} ${isHovered ? "dropdown-menu-link--hovered" : ""}`,
        };
        let dropdownitem = (React.createElement("span", { style: {
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
            }, onKeyPress: item
                ? (ev) => onOptionChange(item, option, onChange, ev)
                : onOptionClick(option), onClick: item
                ? (ev) => onOptionChange(item, option, onChange, ev)
                : onOptionClick(option), role: liRole(option, item), tabIndex: liTabIndex(option, item), ...dataAttributes },
            React.createElement("span", null, option.label),
            React.createElement("span", { style: { display: "flex", alignItems: "center", gap: "8px" } },
                option.extraContext && option.extraContext(item),
                hasSubItems && (React.createElement("span", { className: `glyphicon-pro glyphicon-pro-chevron-${isLeftSubmenu ? "left" : "right"}`, style: { fontSize: "12px", marginRight: "-8px" } })))));
        if (option.link && !getIsDisabled(option, item)) {
            if (option.link.routerLink) {
                const LinkDropdown = option.link.routerLink;
                dropdownitem = (React.createElement(LinkDropdown, { to: getOptionLink(option, item), href: getOptionLink(option, item), ...dataAttributes },
                    React.createElement("span", { style: {
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                        } },
                        React.createElement("span", null, option.label),
                        React.createElement("span", { style: {
                                display: "flex",
                                alignItems: "center",
                                gap: "8px",
                            } },
                            option.extraContext && option.extraContext(item),
                            hasSubItems && (React.createElement("span", { className: `glyphicon-pro glyphicon-pro-chevron-${isLeftSubmenu ? "left" : "right"}`, style: { fontSize: "12px", marginRight: "-8px" } }))))));
            }
            else {
                const target = option.link.newTab ? { target: "_blank" } : {};
                dropdownitem = (React.createElement("a", { href: getOptionLink(option, item), ...dataAttributes, ...target },
                    React.createElement("span", { style: {
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                        } },
                        React.createElement("span", null, option.label),
                        React.createElement("span", { style: {
                                display: "flex",
                                alignItems: "center",
                                gap: "8px",
                            } },
                            option.extraContext && option.extraContext(item),
                            hasSubItems && (React.createElement("span", { className: `glyphicon-pro glyphicon-pro-chevron-${isLeftSubmenu ? "left" : "right"}`, style: { fontSize: "12px", marginRight: "-8px" } }))))));
            }
        }
        return (React.createElement("li", { key: i, className: `${liClassName(option, item)} ${hasSubItems
                ? `dropdown-submenu ${isLeftSubmenu ? "dropdown-submenu--left" : ""}`
                : ""}`, role: "menuitem", "aria-disabled": getIsDisabled(option, item), "data-disabled": getIsDisabled(option, item), "data-testid": option.dataTestId, "data-id": option.dataId, "data-label": option.label, onMouseEnter: (ev) => {
                if (!measured.current) {
                    measured.current = true;
                    const parentMenu = ev.currentTarget.closest(".popper-dropdown-content") ||
                        ev.currentTarget.closest(".dropdown-menu") ||
                        ev.currentTarget.parentElement;
                    if (parentMenu) {
                        const rect = parentMenu.getBoundingClientRect();
                        const spaceOnRight = window.innerWidth - rect.right;
                        if (spaceOnRight < rect.width) {
                            setOpenLeft(true);
                        }
                    }
                }
                setHoveredItemIndex(i);
            }, onMouseLeave: () => setHoveredItemIndex(null) },
            canDisplayTooltip(option, item) ? (React.createElement(Tooltip, { tooltipId: uuidv4(), content: option.tooltip, iconShown: true }, !option.divider && dropdownitem)) : (!option.divider && dropdownitem),
            hasSubItems && isHovered && (React.createElement("ul", { className: `dropdown-menu dropdown-submenu-menu ${isLeftSubmenu ? "dropdown-submenu-menu--left" : ""}` },
                React.createElement(DropdownOptions, { options: option.subItems, id: `${id}-sub-${i}`, item: item, onChange: onChange })))));
    })));
}
const onOptionClick = (option) => !option.disabled ? option.onClick : undefined;
export function canDisplayTooltip(option, item) {
    if (option.tooltipDisplayed && option.tooltipDisplayed(item) === false) {
        return option?.tooltip ? false : true;
    }
    return option?.tooltip;
}
function onOptionChange(item, option, onChange, ev) {
    if (item) {
        !getIsDisabled(option, item) && onChange && onChange(option, ev, item);
    }
}
function getOptionLink(option, item) {
    if (option?.link?.url) {
        let link = option?.link?.url;
        const linkKey = option?.link?.linkKey;
        if (item && linkKey && item[linkKey]) {
            link = link + (linkKey ? `${item[linkKey]}` : "");
        }
        return link;
    }
}
function getIsDisabled(option, item) {
    if (option.disabled === undefined)
        return false;
    if (typeof option.disabled === "boolean")
        return option.disabled;
    return option.disabled(item);
}
function liClassName(option, item) {
    if (getIsDisabled(option, item)) {
        return "disabled";
    }
    return undefined;
}
function liRole(option, item) {
    if (option.sectionHeader) {
        return "presentation";
    }
    if ((!option.onClick && !option.link && !option.subItems) ||
        getIsDisabled(option, item)) {
        return undefined;
    }
    return "link";
}
function liTabIndex(option, item) {
    if (option.divider ||
        option.sectionHeader ||
        (!option.onClick && !option.link && !option.subItems) ||
        getIsDisabled(option, item)) {
        return undefined;
    }
    return 0;
}
export const toCheckIfDisplayed = (option, item) => option.displayed === undefined
    ? true
    : typeof option.displayed === "boolean"
        ? option.displayed !== false
        : option.displayed(item);
